import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Radio, withStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import QuizSubmit from '@anu/components/QuizSubmit';
import LessonGrid from '@anu/components/LessonGrid';
import { highlightText } from '@anu/utilities/searchHighlighter';

const StyledBox = withStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(8),
  },
}))(Box);

const QuizOptions = ({
  question,
  multipleOptions,
  options,
  value,
  isSubmitting,
  isSubmitted,
  onChange,
  onSubmit,
}) => {
  const theme = useTheme();

  return (
    <StyledBox>
      <LessonGrid>
        <Typography component="div" variant="subtitle1" style={{ marginBottom: theme.spacing(1) }}>
          {highlightText(question)}
        </Typography>

        <FormGroup>
          {multipleOptions &&
            options.map((option, index) => (
              <FormControlLabel
                key={option.id}
                label={highlightText(option.value)}
                control={
                  <Checkbox
                    color="primary"
                    value={String(Number.parseInt(option.id, 10))}
                    checked={value ? value.includes(option.id) : false}
                    onChange={(event) => onChange(option.id, event)}
                    data-checkbox-option={option.id}
                    data-test={'anu-lms-checkbox'}
                  />
                }
              />
            ))}

          {!multipleOptions && (
            <FormControl>
              <RadioGroup value={value} onChange={(event) => onChange(event)}>
                {options.map((option, index) => (
                  <FormControlLabel
                    key={option.id}
                    label={highlightText(option.value)}
                    value={option.id}
                    control={
                      <Radio
                        data-radio-option={option.id}
                        value={option.id}
                        checked={option.id === value}
                        color="primary"
                        data-test={'anu-lms-radio'}
                      />
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          )}
        </FormGroup>
        {!isSubmitted && onSubmit && <QuizSubmit onSubmit={onSubmit} isSubmitting={isSubmitting} />}
      </LessonGrid>
    </StyledBox>
  );
};

QuizOptions.propTypes = {
  question: PropTypes.string,
  multipleOptions: PropTypes.bool,
  options: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  correctValue: PropTypes.string,
};

export default QuizOptions;
